import { render, staticRenderFns } from "./SAddress.vue?vue&type=template&id=6cef4646&scoped=true"
import script from "./SAddress.vue?vue&type=script&lang=ts"
export * from "./SAddress.vue?vue&type=script&lang=ts"
import style0 from "./SAddress.vue?vue&type=style&index=0&id=6cef4646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef4646",
  null
  
)

export default component.exports